function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3591 12.6561H11.3563V12.7061C11.3563 13.3964 10.8084 13.957 10.1391 13.957H4.18424C3.51499 13.957 2.96701 13.3964 2.96701 12.7061V3.62612H11.3591V12.6561ZM12.8474 2.74898H10.0601V2.32406C10.0601 1.4486 9.36611 0.73418 8.5102 0.73418H5.81314C4.95723 0.73418 4.26321 1.4486 4.26321 2.32406V2.74898H1.47596C1.23684 2.74898 1.04747 2.94531 1.04747 3.18755C1.04747 3.42979 1.23684 3.62612 1.47596 3.62612H2.11004V12.7061C2.11004 13.878 3.03956 14.8342 4.18424 14.8342H10.1391C11.2838 14.8342 12.2133 13.878 12.2133 12.7061V3.62612H12.8474C13.0865 3.62612 13.2759 3.42979 13.2759 3.18755C13.2759 2.94531 13.0865 2.74898 12.8474 2.74898ZM5.12018 2.32406C5.12018 1.9302 5.43266 1.61132 5.81314 1.61132H8.5102C8.89068 1.61132 9.20316 1.9302 9.20316 2.32406V2.74898H5.12018V2.32406Z",
  strokeWidth: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.16175 12.6635C7.40087 12.6635 7.59024 12.4672 7.59024 12.2249V5.35732C7.59024 5.11508 7.40087 4.91875 7.16175 4.91875C6.92264 4.91875 6.73326 5.11508 6.73326 5.35732V12.222C6.73326 12.4638 6.92216 12.6635 7.16175 12.6635Z",
  strokeWidth: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.6919 12.2354C4.93102 12.2354 5.12039 12.0391 5.12039 11.7968V5.78408C5.12039 5.54184 4.93102 5.34551 4.6919 5.34551C4.45279 5.34551 4.26342 5.54184 4.26342 5.78408V11.7968C4.26342 12.0393 4.45583 12.2354 4.6919 12.2354Z",
  strokeWidth: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.63184 12.2354C9.87096 12.2354 10.0603 12.0391 10.0603 11.7968V5.78408C10.0603 5.54184 9.87096 5.34551 9.63184 5.34551C9.39273 5.34551 9.20336 5.54184 9.20336 5.78408V11.7968C9.20336 12.0391 9.39273 12.2354 9.63184 12.2354Z",
  strokeWidth: 0.1
});

var SvgTrashcan = function SvgTrashcan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    fill: "#F0640C",
    stroke: "#F0640C",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashcan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashcan.39cf5c39.svg";
export { ForwardRef as ReactComponent };